import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuthorizationHeader, http } from '../../config/http';
import LayoutsKasir from '../../layouts/LayoutsKasir';
import { DinamicTitle } from '../../utils/DinamicTitle';
import DetailBarangPenjualan from './DetailBarangPenjualan';

export default function Penjualan() {
  DinamicTitle('Penjualan || Komaladewi');

  const [itemCabang, setItemCabang] = useState([]);
  const [loading, setLoading] = useState(false);
  const [kodeItem, setKodeItem] = useState('');

  const navigate = useNavigate();
  const inputRef = useRef(null);

  const handleReset = () => {
    setKodeItem('');
    setItemCabang([]);
    inputRef.current?.focus();
  };

  useEffect(() => {
    inputRef.current?.focus();
    const handleKeyDown = (e) => {
      if (e.key?.toLocaleLowerCase() === 'i' && e.ctrlKey) {
        e.preventDefault();
        inputRef.current?.focus();
        inputRef.current?.select?.();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        handleReset();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  async function getItemCabang(codeToSearch) {
    const code = (codeToSearch !== undefined ? codeToSearch : kodeItem)?.trim();
    if (!code) {
      setItemCabang([]);
      return;
    }
    setLoading(true);
    try {
      const res = await http.get(`/item/search/${code}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      if (res.data?.data === null) {
        toast.warning('Data kosong', { autoClose: 600 });
        setItemCabang([]);
      } else {
        setItemCabang(res.data.data);
        setTimeout(() => {
          const el = document.getElementById('input-harga-total');
          if (el) {
            el.focus();
            el.select?.();
          }
        }, 100);
      }
      return res.data?.data;
    } catch (err) {
      if (err.response === undefined) {
        return null;
      } else if (err.response.status === 422 || err.response.status === 409) {
        toast.error(err.response?.data?.message || 'Barang tidak dapat ditransaksikan!', { autoClose: 3500 });
        setItemCabang([]);
      } else if (err.response.status === 404) {
        if (code.length >= 8) {
          toast.error('Data tidak ditemukan', { autoClose: 600 });
        }
        setItemCabang([]);
      } else if (err.response.status === 401) {
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const trimmed = kodeItem.trim();
    if (trimmed === '') {
      setItemCabang([]);
    } else if (trimmed.length >= 8) {
      getItemCabang(trimmed);
    } else {
      if (itemCabang && (Array.isArray(itemCabang) ? itemCabang.length > 0 : itemCabang.id)) {
        setItemCabang([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kodeItem]);

  const handleKeyDownInput = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      getItemCabang(kodeItem);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      handleReset();
    }
  };

  return (
    <LayoutsKasir>
      <div className="w-full max-w-4xl mx-auto py-2.5">
        <div className="relative flex items-center">
          <div className="absolute left-4 z-10 w-11 h-11 rounded-xl bg-amber-500 text-white flex items-center justify-center shadow-sm pointer-events-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
          <input
            ref={inputRef}
            type="text"
            id="MySearch"
            value={kodeItem}
            onChange={(e) => setKodeItem(e.target.value)}
            onKeyDown={handleKeyDownInput}
            className="w-full h-16 pl-[72px] pr-20 text-lg sm:text-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-[#152037] text-slate-800 dark:text-slate-100 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 focus:border-amber-500 placeholder:text-slate-400 dark:placeholder:text-slate-500 transition-all font-medium"
            placeholder="Cari Item (Barcode / Kode Item)..."
          />
          {kodeItem && (
            <button
              type="button"
              onClick={handleReset}
              className="absolute right-4 p-2 rounded-xl text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition cursor-pointer"
              title="Hapus pencarian (Esc)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      </div>
      <div className="w-full max-w-4xl mx-auto">
        <DetailBarangPenjualan
          itemCabang={itemCabang}
          detailPenjualan={itemCabang}
          loading={loading}
          kodeItem={kodeItem}
          onReset={handleReset}
        />
      </div>
    </LayoutsKasir>
  );
}
